<app-page>
  <trade-creator-modal></trade-creator-modal>
</app-page>
